import React from "react";
import { useNavigate } from "react-router-dom";
import StarRating from "../components/StarRating";

export default function RankingTable({ brokerages, highlightId = null }) {
  const navigate = useNavigate();

  if (!brokerages || brokerages.length === 0) {
    return (
      <p className="text-gray-500 text-center py-6">No brokerages found.</p>
    );
  }

  return (
    <div className="w-full max-w-3xl mx-auto backdrop-blur-sm rounded-xl shadow-lg overflow-x-auto">
      <table className="w-full bg-white/90 table-fixed">
        <thead className="bg-gray-300">
          <tr>
            <th className="w-16 py-3 px-4 text-center font-semibold text-gray-700">
              Rank
            </th>
            <th className="w-60 py-3 px-4 text-center font-semibold text-gray-700">
              Name
            </th>
            <th className="w-32 py-3 px-4 text-center font-semibold text-gray-700">
              Score
            </th>
          </tr>
        </thead>
        <tbody>
          {brokerages.map((b, idx) => (
            <tr
              key={`${b.id}-${idx}`}
              className={`cursor-pointer transition border-b border-gray-300 ${
                highlightId && b.id === highlightId
                  ? "bg-yellow-100 hover:bg-yellow-200"
                  : "hover:bg-blue-50"
              }`}
              onClick={() => navigate(`/brokerage/${b.id}`)}
            >
              <td className="text-center py-2 px-4 text-gray-800">{b.rank}</td>
              <td className="text-center w-72 py-2 px-4 text-blue-700 underline">
                {b.name}
              </td>
              <td className="text-center py-2 px-4 text-gray-800">
                {Math.round(b.score)} <StarRating score={b.score} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
